import { FormFieldConfig } from "interfaces/forms";

type field = "startDate" | "endDay";

const fieldFormPeriodoInsc: FormFieldConfig<field> = {
  startDate: {
    name: "startDate",
    label: "Inicio",
    type: "date",
    errorMsg: "Informe data de inicio",
  },
  endDay: {
    name: "endDay",
    label: "Final",
    type: "date",
    errorMsg: "Informe data de final",
  },
};

export default fieldFormPeriodoInsc;
